export function formatErrorMessage(error, i18nMessage) {
  let customMessage = i18nMessage ? i18nMessage : '';
  let messageFromErrorArray = error && error.data && error.data.errors && error.data.errors[0] && error.data.errors[0].message;
  return error instanceof Error ? error.message : (error && error.data ? (error.data.message || messageFromErrorArray) : customMessage);
}



// WEBPACK FOOTER //
// ./src/app/utils/error.js